import { PlusOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import { type MouseEvent } from "react"

interface AddStepButtonProps {
  onAdd: () => void
  disabled?: boolean
  disabledReason?: string
}

const AddStepButton = ({
  onAdd,
  disabled = false,
  disabledReason,
}: AddStepButtonProps) => (
  <Tooltip title={disabled ? disabledReason : "Add step"}>
    <Button
      type="dashed"
      size="small"
      disabled={disabled}
      aria-label="Add step"
      onClick={(event: MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        if (disabled) return
        onAdd()
      }}
      style={{
        width: 18,
        height: 18,
        minWidth: 18,
        padding: 0,
        lineHeight: 0,
      }}
    >
      <PlusOutlined style={{ fontSize: 10, color: "#8c8c8c" }} />
    </Button>
  </Tooltip>
)

export default AddStepButton
